import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { SettingsOverviewDataProvider } from '@services/settings/settings-overview/settings-overview.data.service';
import {
	CompanySettingsList,
	SettingsOverview,
	SettingsOverviewListItem
} from '@models/brands.model';
import { filter, takeUntil } from 'rxjs/operators';
import { User } from '@models/models';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'settings-overview',
	template: require('./settings-overview.component.html'),
	styles: [require('./settings-overview.component.scss')],
	encapsulation: ViewEncapsulation.None
})
export class SettingsOverviewComponent implements OnInit, OnDestroy {
	settingsLists: SettingsOverview;
	companySettingsList: CompanySettingsList;
	companySettingsType: CompanySettingsList[] = [];
	companySettingsTypeToSave: CompanySettingsList[] = [];
	user: User;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private settingsOverviewService: SettingsOverviewDataProvider,
		private accountService: AccountServiceWebProvider
	) {}

	ngOnInit(): void {
		this.getUser();
		this.getSettingsOverviewList();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private getUser(): void {
		this.accountService.userDataObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((user: User): void => {
				this.user = user;
			});
	}

	private getSettingsOverviewList(): void {
		this.settingsOverviewService
			.settingsOverview()
			.pipe(filter(data => data !== null))
			.subscribe((data: SettingsOverview): void => {
				this.settingsLists = data;
				if (data.companySettings) {
					const retrievedObject = localStorage.getItem(
						`${this.settingsLists.currentCompanyId}${this.user.id}`
					);
					const parsedLocal = JSON.parse(retrievedObject);
					if (parsedLocal) {
						const fromBE = JSON.stringify(data.companySettings);
						const fromLocalStorage = JSON.stringify(
							parsedLocal.reduce(
								(prev, curr) => [...prev, ...curr.companySettingsList],
								[]
							)
						);
						if (fromBE !== fromLocalStorage) {
							this.createCompanySettingsStructure(data, parsedLocal);
						} else {
							this.companySettingsType = parsedLocal;
						}
					} else {
						localStorage.setItem('activeUser', this.user.id.toString());
						localStorage.setItem(
							'currentCompanyId',
							this.settingsLists.currentCompanyId.toString()
						);
						this.createCompanySettingsStructure(data);
					}
				}
			});
	}

	private createCompanySettingsStructure(data, parsedLocal = null): void {
		const parsedKeys: any = {};
		if (parsedLocal) {
			parsedLocal.forEach(category => {
				parsedKeys[category.name] = {
					itemsCount: category.companySettingsList.length,
					expanded: category.expandedIn
				};
			});
		}
		const companySettingsTypes = [];
		data.companySettings.forEach(el => {
			companySettingsTypes.push(el.companySettingsType);
		});
		const newSet = new Set(companySettingsTypes);
		const setArray = [...newSet];

		setArray.forEach(el => {
			this.companySettingsList = {
				expandedIn: true,
				name: el,
				companySettingsList: [
					...data.companySettings.filter(obj => obj.companySettingsType === el)
				]
			};
			if (parsedKeys[el]) {
				this.companySettingsList.expandedIn =
					parsedKeys[el].expanded ||
					this.companySettingsList.companySettingsList.length !==
						parsedKeys[el].itemsCount;
			}
			this.companySettingsType.push(this.companySettingsList);
		});
	}

	saveExpanded(event: any, index: number): void {
		this.companySettingsType[index].expandedIn =
			event.currentTarget.ariaExpanded !== 'true';
		if (!event.currentTarget.ariaExpanded) {
			const expanded =
				event.currentTarget.getAttribute('aria-expanded') === 'true';
			event.currentTarget.setAttribute('aria-expanded', !expanded);
			this.companySettingsType[index].expandedIn =
				event.currentTarget.getAttribute('aria-expanded') === 'true';
		}
		localStorage.setItem(
			`${this.settingsLists.currentCompanyId}${this.user.id}`,
			JSON.stringify(this.companySettingsType)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/settings-overview/settings-overview.component.ts